import { css, StyleDeclaration } from 'aphrodite';
import { bs } from '../../../../styles/styles';

export function SparkleIcon({
	styles = [],
	...props
}: Omit<React.SVGProps<SVGSVGElement>, 'className'> & { styles?: StyleDeclaration[] }) {
	return (
		<svg
			width={24}
			height={24}
			viewBox='0 0 24 24'
			className={css(bs.block, bs.textBrandPrimary, ...styles)}
			{...props}
		>
			<path
				fill='currentColor'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 1C12 6.98399 16.4772 11.835 22 11.835C16.4772 11.835 12 16.686 12 22.67C12 16.686 7.52285 11.835 2 11.835C7.52285 11.835 12 6.98399 12 1'
			/>
		</svg>
	);
}
